function setupCliContextMenu(installationId, installationNumber, cid, currentUserEmail) {
	var menu = {
		a1: {
			name: 'Available devices',
			items: addAvailableDevices()
		},
		swipeTag: {
			name: 'Swipe tag',
			items: tags()
		},
		b0: '---------',
		b1: {
			name: 'Random string',
			callback: function() {
				showResponse(this, randomString());
			}
		},
		b2: {
			name: 'Password',
			callback: function() {
				showResponse(this, 'asdf1234');
			}
		},
		b3: {
			name: 'UK postal code',
			callback: function() {
				showResponse(this, 'L75 1HP');
			}
		},
		ba0: '---------',
		ba1: {
			name: 'Kill me',
			callback: function() {
				$.contextMenu('destroy');
			}
		}
	};
	var userMenu = {
		c0: '---------',
		c1: {
			name: 'Remove installation errors',
			callback: function() {
				query(this, 'deleteInstallationErrors.cmd?email=' + currentUserEmail);
			}
		},
		c4: {
			name: 'Reset sms tokens',
			callback: function() {
				query(this, 'resetSmsTokens.cmd?email=' + currentUserEmail);
			}
		},
		c5: {
			name: 'Reset user token',
			callback: function() {
				query(this, 'resetUserToken.cmd?email=' + currentUserEmail);
			}
		},
		c8: {
			name: 'Reset wizard state',
			items: [{
				name: 'for create installation wizard',
				callback: function() {
					query(this, 'resetCreateInstallationWizardState.cmd');
				}
			}, {
				name: 'for add device wizard',
				callback: function() {
					query(this, 'resetAddDeviceWizardState.cmd?instId=' + installationId);
				}
			}]
		}
	};
	var installationMenu = {
		c3: {
			name: 'Remove current installation',
			callback: function() {
				if (confirm('Are you sure you want to delete this installation?')) {
					query(this, 'deleteInstallation.cmd?email=' + currentUserEmail + '&internalId=' + installationId);
				}
			}
		},
		c6: {
			name: 'Unverify installation',
			callback: function() {
				if ('${installation}') {
					query(this, 'unverify.cmd?email=' + currentUserEmail + '&internalId=' + installationId);
				} else {
					alert('No installation loaded');
				}
			}
		},
		d0: '---------',
		d1: {
			name: 'Installation IDs',
			callback: function() {
				if (installationId) {
					alert('Cid: ' + cid + ', External ID (ins_no): ' + installationNumber + ', Internal ID (s#ins): ' + installationId);
				} else {
					alert('No installation loaded');
				}
			}
		}
	};
	var formFillMenu = {
		e0: '---------',
		e1: {
			name: 'Form fill',
			items: {
				createAccount: {
					name: 'Create account',
					callback: function() {
						$('#firstName').val('Test');
						$('#lastName').val('Testsson');
						$('#mobilePhoneNumber').val('999123456');
						$('#createAccountForm').find('#createAccountEmail').val('@verisure.com');
						$('#createAccountForm').find('#createAccount_password').val('asdf1234');
						$('#createAccountForm').find('#createAccount_confirmPassword').val('asdf1234');
						$('#createAccountForm').find('#agree1').prop('checked', true);
						$('#createAccountForm').find('#createAccountEmail').focus();
					}
				},
				wizardAddress: {
					name: 'Wizard address',
					callback: function() {
						var d = new Date();
						$('#street1').val('Din Gata ' + d.getHours() + ':' + d.getMinutes());
						$('#zipCode').val('12345');
						$('#city').val('Malmeu');
						$('#phoneNumber').val('999123456');
						$('#premisesType').val('DETAHOUS');
					}
				},
				addSecom: {
					name: 'Add secom',
					callback: function() {
						query(this, 'availablesecom.cmd');
					}
				}
			}
		}
	};

	var tokenMenu = {
		f0: '---------',
		f1: {
			name: 'Tokens',
			items: {
				userType1: {
					name: 'User token type 1',
					callback: function() {
						query(this, 'userTokenType1.cmd?email=' + currentUserEmail);
					}
				},
				userType2: {
					name: 'User token type 2',
					callback: function() {
						query(this, 'userTokenType2.cmd?email=' + currentUserEmail);
					}
				},
				test: {
					name: 'Test token',
					callback: function() {
						showResponse(this, 'abcde');
					}
				}
			}
		}
	};

	function addAvailableDevices() {
		var items = {};
		var devices = [
			{type: 'CAMERA1'},
			{type: 'CAMERAPIR3'},
			{type: 'CONTROLPLUG1'},
			{type: 'DOORLOCK1'},
			{type: 'DOORLOCK2'},
			{type: 'GATEWAY2'},
			{type: 'GATEWAY3', item: 182080},
			{type: 'GATEWAY MICRO', item: 182061},
			{type: 'HEATPUMP1'},
			{type: 'HOMEPANEL1'},
			{type: 'HUMIDITY1'},
			{type: 'KEYFOB1', item: 280786},
			{type: 'MAGNETIC2'},
			{type: 'MAGNETIC3'},
			{type: 'MINIOUTDOORKEYPAD1'},
			{type: 'MOUSE1'},
			{type: 'SIREN1'},
			{type: 'SMARTCAMERA1'},
			{type: 'SMARTDOT1'},
			{type: 'SMOKE3'},
			{type: 'SMOKE4'},
			{type: 'SIRENVOICEKEYPAD1'},
			{type: 'VOICEBOX1'},
			{type: 'WATER2'},
		];
		_.each(devices, function(device) {
			items[device.type] = {
				name: device.type,
				callback: function() {
					if (device.item) {
						query(this, 'availableDevice.cmd?item=' + device.item);
					} else {
						query(this, 'availableDevice.cmd?type=' + device.type);
					}
				}
			};
		});
		return items;
	}

	function tags() {
		var items = {};
		var availableTags = ['Doorlock', 'Red', 'Black', 'Blue', 'Brown', 'White', 'Green', 'Pink'];
		_.each(availableTags, function(e) {
			items[e] = {
				name: e,
				callback: function(key) {
					query(this, 'swipeTag.cmd?tag=' + key + '&instId=' + cid);
				}
			};
		});
		return items;
	}

	$(document).ready(function() {
		$.contextMenu({
			selector: 'input, .global-navigation-item--icon',
			items: _.extend(menu, currentUserEmail ? userMenu : {}, installationId ? installationMenu : {}, tokenMenu, formFillMenu)
		});
	});

	function query(clickedElement, command) {
		$.ajax({
			url: '/mgwutil/' + command
		}).done(function(data) {
			showResponse(clickedElement, data);
		}).fail(function(jqXHR, textStatus, errorThrown) {
			var error = errorThrown ? 'Error: ' + errorThrown : '';
			alert('Ouch, something went wrong. There is probably a nasty stacktrace in your server log. You could try and go to the CLI Tool and see if it works there.' + error);
		});
	}

	function showResponse(clickedElement, data) {
		if (typeof data === 'string') {
			if (clickedElement.is(':input')) {
				clickedElement.val(data).change();
			} else {
				alert(data);
			}
		} else {
			_.each(data, function(value, key) {
				$('input[name="' + key + '"]').val(value).change();
			});
		}
	}

	function randomString() {
		return Math.random().toString(36).substring(7);
	}
}
